// Utilitario de periodo para o dashboard
// Calcula ranges current/previous para qualquer granularidade

export type Period = "today" | "7d" | "30d";

export interface PeriodRange {
  current: { start: Date; end: Date };
  previous: { start: Date; end: Date };
  days: number;
}

/**
 * Resolve o PeriodRange a partir de um Period.
 * `previous` e o bloco imediatamente anterior ao `current` de mesma duracao.
 */
export function resolvePeriod(period: Period, now: Date = new Date()): PeriodRange {
  // Zeramos horas para nao misturar fuso no current.end
  const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);

  switch (period) {
    case "today": {
      const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const startOfYesterday = new Date(startOfToday);
      startOfYesterday.setDate(startOfYesterday.getDate() - 1);
      const endOfYesterday = new Date(startOfToday.getTime() - 1);
      return {
        current: { start: startOfToday, end: endOfDay },
        previous: { start: startOfYesterday, end: endOfYesterday },
        days: 1,
      };
    }
    case "7d": {
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6);
      const prevEnd = new Date(start.getTime() - 1);
      const prevStart = new Date(prevEnd.getFullYear(), prevEnd.getMonth(), prevEnd.getDate() - 6);
      return {
        current: { start, end: endOfDay },
        previous: { start: prevStart, end: prevEnd },
        days: 7,
      };
    }
    case "30d":
    default: {
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 29);
      const prevEnd = new Date(start.getTime() - 1);
      const prevStart = new Date(prevEnd.getFullYear(), prevEnd.getMonth(), prevEnd.getDate() - 29);
      return {
        current: { start, end: endOfDay },
        previous: { start: prevStart, end: prevEnd },
        days: 30,
      };
    }
  }
}
